import { useEffect, useState } from "react";
import { api } from "../..";
import { useNavigate, useParams } from "react-router-dom";
import QueueStats from "./QueueStats/QueueStats";
import LiveQueue from "./LiveQueue/LiveQueue";
import History from "./History/History";
import Spinner from "../../Components/Spinner/Spinner";
import { toast } from "react-toastify";
import Agents from "./Agents/Agents";

function Queue() {
	const [queue, setQueue] = useState({});
	const navigate = useNavigate();
	const { id } = useParams();

	useEffect(() => {
		if(api.isLoggedIn()) {
			if(id) {
				api.calls.queue.read(id)
				.then((r: any) => {
					setTimeout(() => {
						setQueue(r.data)
					}, 2000)
				} )

			} else {
				toast.error('Unable to get queue.');
			}
		} else {
			navigate("/login");
		}
		// eslint-disable-next-line
	}, []);

	if(Object.keys(queue).length === 0) {
		return <span className='loading-spinner'>
			<Spinner />
		</span>
	}

	return <div className="queue-panel">
		<div className="queue-stat-panel">
			<QueueStats queue={queue} />
		</div>
		<div className="call-history-panel">
			<History />
		</div>
		<div className="live-queue-panel">
			<LiveQueue />
		</div>
		<div className="agents-panel">
			<Agents />
		</div>
	</div>
}

export default Queue;
